import {
  getDetail,
  saveOrder,
  getVirtualChannels
} from '@/api/singleGoods.js'

const state = {
}

const mutations = {
}

const actions = {
  // 商品详情
  getDetail(temp, data) {
    return new Promise((resolve, reject) => {
      getDetail(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 商品下订
  saveOrder(temp, data) {
    return new Promise((resolve, reject) => {
      saveOrder(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 虚拟商品下订渠道
  getVirtualChannels(temp, data) {
    return new Promise((resolve, reject) => {
      getVirtualChannels(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
